import React from "react";
import { useParams } from "react-router-dom";
import { withPermissions } from "components/with-permisisons";
import { EvtClientCard } from "components/client/display-card";
import { fetchProjectClient } from "../api";
import { useFetch } from "@/hooks/useFetch";
import { EvtClientLoaderCard } from "components/client/loader";
import { useProject } from "../context";

const ClientCard = () => {
  const { project_slug } = useParams();
  const { id } = useProject();

  const { data: user, isLoading } = useFetch({
    queryKey: [id],
    queryFn: () => fetchProjectClient({ id }),
  });

  if (isLoading) {
    return <EvtClientLoaderCard />;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-gray-600">Client</div>
      <EvtClientCard user={user} />
    </div>
  );
};

export const ProjectClientCard = withPermissions(ClientCard, {
  collection: "clients",
  action: "read",
});
